import { render, staticRenderFns } from "./mosaico.vue?vue&type=template&id=4bed4fe2&scoped=true&"
import script from "./mosaico.vue?vue&type=script&lang=js&"
export * from "./mosaico.vue?vue&type=script&lang=js&"
import style0 from "./mosaico.vue?vue&type=style&index=0&id=4bed4fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed4fe2",
  null
  
)

export default component.exports